import type { IFindMySchoolSchoolItem } from "@/providers/store/api/find-my-school/find-my-school.interface";

import {
  isSchoolLevelType,
  SCHOOL_LEVEL_TYPE_ORDER,
  sortSchoolLevelTypeStrings,
} from "./school-level-display.utils";

function getSchoolSortOrder(school: IFindMySchoolSchoolItem): number {
  const primaryType = sortSchoolLevelTypeStrings(school.schoolTypes)[0];

  if (!primaryType || !isSchoolLevelType(primaryType)) {
    return Number.POSITIVE_INFINITY;
  }

  return SCHOOL_LEVEL_TYPE_ORDER[primaryType];
}

export function sortFindMySchoolSchools(
  schools: readonly IFindMySchoolSchoolItem[],
): IFindMySchoolSchoolItem[] {
  return [...schools].sort((a, b) => {
    const orderDiff = getSchoolSortOrder(a) - getSchoolSortOrder(b);
    if (orderDiff !== 0) {
      return orderDiff;
    }

    return (a.name ?? "").localeCompare(b.name ?? "");
  });
}
